/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMeasurement } from './APIMeasurement';
import {
    APIMeasurementFromJSON,
    APIMeasurementFromJSONTyped,
    APIMeasurementToJSON,
} from './APIMeasurement';

/**
 * The serializer that enables the high level PartViewSet. This is basically
 * a simple form of the ArticleSerializer that is optimized to work with
 * the automated quote generation feature.
 * @export
 * @interface APIPartCreation
 */
export interface APIPartCreation {
    /**
     * 
     * @type {string}
     * @memberof APIPartCreation
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartCreation
     */
    name?: string;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPartCreation
     */
    weight?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPartCreation
     */
    length?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPartCreation
     */
    width?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPartCreation
     */
    height?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPartCreation
     */
    volume?: APIMeasurement | null;
    /**
     * 
     * @type {string}
     * @memberof APIPartCreation
     */
    manufacturingProcess: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartCreation
     */
    material: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIPartCreation
     */
    treatments?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIPartCreation
     */
    estimatedPrice?: string;
    /**
     * The guest request that this article was created for.
     * @type {string}
     * @memberof APIPartCreation
     */
    guestRequest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPartCreation
     */
    partId: string;
}

/**
 * Check if a given object implements the APIPartCreation interface.
 */
export function instanceOfAPIPartCreation(value: object): value is APIPartCreation {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('manufacturingProcess' in value) || value['manufacturingProcess'] === undefined) return false;
    if (!('material' in value) || value['material'] === undefined) return false;
    if (!('partId' in value) || value['partId'] === undefined) return false;
    return true;
}

export function APIPartCreationFromJSON(json: any): APIPartCreation {
    return APIPartCreationFromJSONTyped(json, false);
}

export function APIPartCreationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPartCreation {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'name': json['name'] == null ? undefined : json['name'],
        'weight': json['weight'] == null ? undefined : APIMeasurementFromJSON(json['weight']),
        'length': json['length'] == null ? undefined : APIMeasurementFromJSON(json['length']),
        'width': json['width'] == null ? undefined : APIMeasurementFromJSON(json['width']),
        'height': json['height'] == null ? undefined : APIMeasurementFromJSON(json['height']),
        'volume': json['volume'] == null ? undefined : APIMeasurementFromJSON(json['volume']),
        'manufacturingProcess': json['manufacturing_process'],
        'material': json['material'],
        'treatments': json['treatments'] == null ? undefined : json['treatments'],
        'estimatedPrice': json['estimated_price'] == null ? undefined : json['estimated_price'],
        'guestRequest': json['guest_request'] == null ? undefined : json['guest_request'],
        'partId': json['part_id'],
    };
}

export function APIPartCreationToJSON(value?: Omit<APIPartCreation, 'self'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'weight': APIMeasurementToJSON(value['weight']),
        'length': APIMeasurementToJSON(value['length']),
        'width': APIMeasurementToJSON(value['width']),
        'height': APIMeasurementToJSON(value['height']),
        'volume': APIMeasurementToJSON(value['volume']),
        'manufacturing_process': value['manufacturingProcess'],
        'material': value['material'],
        'treatments': value['treatments'],
        'estimated_price': value['estimatedPrice'],
        'guest_request': value['guestRequest'],
        'part_id': value['partId'],
    };
}

